<template>
    <h1 className="p-no text-transparent">
        【媽咪節選禮指南】母親節限時優惠！PChome 24h 購物指定支付享高額回饋！
    </h1>
    <HeaderTop />
    <LeftMenu />
    <div class="wrap">
        <div class="kvBg absolute pe-none">
            <img src="@/assets/new/kv_bg.png" alt="kv bg" class="d-lg-block d-none w-100">
        </div>
        <div class="kvBox">
            <div class="eventGuide absolute" data-bs-toggle="modal" data-bs-target="#calendar">
                <span><img src="@/assets/new/event_guide.png" alt="攻略" class="d-block"></span>
            </div>
            
            <!-- 大標 -->
            <div class="kvTitle absolute pe-none">
                <template v-for="(item, index) in otherData" :key="item.uniqueIdentifier">
                    <img v-if="index === 1" :src="item.Img.Src" alt="約會女神節" class="d-block">
                </template>
            </div>
            <!-- END // 大標 -->

            <!-- 3大塊bn -->
            <div class="absolute" id="topbn" v-if="topBnData !=''">
                <ul class="row justify-content-center align-items-end">
                    <template v-for="(item, index) in topBnData" :key="index">
                        <li class="col-4" v-if="index <=2" :key="index"><linkImg :item="item"/></li>
                    </template>
                </ul>
            </div>
            <!-- END // 3大塊bn -->

            <div class="smallP absolute d-lg-block d-none">
                <span>
                    <img src="@/assets/new/kv_smallP-2.png" alt="deco" class="p2 d-block">
                </span>
                <img src="@/assets/new/kv_smallP-1.png" alt="deco" class="p1 d-block">
            </div>
            <div class="supermom absolute pe-none">
                <img src="@/assets/new/supermom_kv.svg" alt="supermom" class="d-block">
            </div>
            <img src="@/assets/new/kv_bigP.png" alt="bg" class="d-lg-block d-none pe-none bigP w-100">
        </div>


        <!-- 活動BN們 -->
        <section id="allBnBox">
            <div class="deco absolute">
                <img src="@/assets/new/allBnBox_deco.png" alt="deco" class="d-block">
            </div>
            <div class="outBox">
                <div class="container">
                    <!-- 超級優惠 -->
                    <div class="superRebate">
                        <template v-for="(item, index) in topBnData" :key="index">
                            <a v-if="index >= 3" :href="getLinkUrl(item)" class="absolute"  :class="item.Link.Url === '#nolink' ? 'pe-none' : ''" :target="target(item)" @click="goTo($event, item)"></a>
                        </template>
                        <template v-for="(item, index) in topBnData" :key="index">
                            <img v-if="index === 3" :src="item.Img.Src" :alt="item.Link.Text" class="d-lg-block d-none w-100">
                            <img v-if="index === 4" :src="item.Img.Src" :alt="item.Link.Text" class="d-lg-none d-block">
                        </template>
                    </div>
                    <!-- END // 超級優惠 -->
                    
                    <div class="gridBox">
                        <div class="gridBox--left">
                            <onSaleNowFirst v-if="onSaleNowFirst" :item="onSaleNowFirst" id="dailysale_ad"/>
                            <ul class="bnEventBig" v-if="bnEvent_1Data">
                                <template v-for="(item, index) in bnEvent_1Data">
                                    <li class="col-12" v-if="index <3" :key="index" :id="'event_'+(index+1)">
                                        <linkImg :item="item"/>
                                    </li>
                                </template>
                            </ul>
                        </div>
                        <div class="gridBox--right">
                            <div class="d-flex heroBn" id="sbd_today" v-if="bnHeroData !=''">
                                <swiper :modules="modules" :loop="true" :slides-per-view="1" :space-between="15" :speed="1000" :pagination="{ clickable: true }"
                                :autoplay="{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                }"
                                >
                                    <swiper-slide v-for="item in bnHeroData" :key="item.uniqueIdentifier">
                                        <slideBn :item="item"/>
                                    </swiper-slide>
                                </swiper>
                            </div>
                            <ul class="row bnEvent_2" v-if="bnEvent_2Data">
                                <template v-for="(item, index) in bnEvent_2Data" :key="index">
                                    <li class="col-6"  :id="'event_ad_'+(index+4)">
                                        <linkImg :item="item"/>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                    <ul class="row couponreview" id="couponreview">
                        <template v-for="(item, index) in couponBnData" :key="index">
                            <li class="col-lg-6 col-12"><linkImg :item="item" /></li>
                        </template>
                    </ul>
                </div>
            </div>
            
        </section>
        <!-- END // 活動BN們 -->

        <!-- 右選單, APP選單 -->
        <div id="appTopNav">
            <RightMenu :menuData="hashMenu" :otherData="otherData"/>
        </div>
        <!-- END // 右選單, APP選單 -->

        <!-- 銀行 -->
        <section id="bank" v-if="bankWebData !='' && bankAppData !=''">
            <div class="bankBox d-lg-block d-none" v-if="bankWebData">
                <bankSlide :data="bankWebData" :item="bankWebData"/>
            </div>
            <div class="bankBox d-lg-none d-block" v-if="bankAppData">
                <bankSlide :data="bankAppData" :item="bankAppData"/>
            </div>
        </section>
        <!-- END // 銀行 -->

        <!-- 加碼必看 -->
        <section class="previewMore" id="discount" v-if="previewMoreData !=''">
            <div class="h6">
                <img src="@/assets/new/sect_title_1.png" alt="加碼必看" class="d-block">
            </div>
            <div class="container">
                <ul class="row">
                    <template v-for="(item, index) in previewMoreData" :key="index">
                        <previewMoreAD :item="item" />
                    </template>
                </ul>
            </div>
        </section>
        <!-- END // 加碼必看 -->
        
        <!-- 強檔預告 -->
        <section id="sbdpreview" v-if="sbdpreviewData !=''">
            <div class="h6">
                <img src="@/assets/new/sect_title_2.png" alt="強檔預告" class="d-block">
            </div>
            <div class="outBox">
                <cardSlide :data="sbdpreviewData"/>
            </div>
        </section>
        <!-- END // 強檔預告 -->

        
        <!-- 深粉主題 -->
        <div class="deepPink" :class="{
                'short--1': saleAuctionData.length > 8 && supersaleData.length < 1,
                'short--2': saleAuctionData.length > 8 && supersaleData.length >= 1,
                'short--3': saleAuctionData.length <= 8 && supersaleData.length >= 1,
                'short--4': saleAuctionData.length <= 8 && supersaleData.length < 1,
                'short--5': saleAuctionData.length < 1 && supersaleData.length >= 1
            }" v-if="saleAuctionData.length >1 || supersaleData.length>1">
            <div class="bgLine top absolute">
                <img src="@/assets/new/bg_line-app.png" alt="bg_line" class="d-lg-none d-block">
            </div>
            <div class="supermom absolute d-lg-block d-none">
                <img src="@/assets/new/supermom_body.png" alt="supermom" class="d-block">
            </div>
            <!-- 24H 快速送禮 -->
            <section id="supersale" v-if="supersaleData != ''">
                <div class="h6">
                    <img src="@/assets/new/sect_title_3.png" alt="24H 快速送禮" class="d-block">
                </div>
                <div class="outBox">
                    <div class="container">
                        <ul class="row">
                            <oneDay v-for="(item, index) in supersaleData" :item="item" :key="index"/>
                        </ul>
                    </div>
                </div>
            </section>
            <!-- END // 24H 快速送禮 -->

            <!-- 願望清單 -->
            <section id="wishlist" v-if="saleAuctionData != ''">
                <div class="h6">
                    <img src="@/assets/new/sect_title_4.png" alt="願望清單" class="d-block">
                </div>
                <div class="outBox">
                    <div class="container">
                        <ul class="row">
                            <superPD v-for="(item, index) in saleAuctionData" :item="item" :key="index" :index="index"/>
                        </ul>
                    </div>
                    <div class="text_01 btm d-md-block d-none">
                        <img src="@/assets/new/wishlist_text-01.png" alt="deco" class="d-block">
                    </div>
                    <div class="text_02 top d-md-block d-none">
                        <img src="@/assets/new/wishlist_text-02.png" alt="deco" class="d-block">
                    </div>
                </div>
            </section>
            <!-- END // 願望清單 -->
            <div class="bgLine btm absolute pe-none">
                <img src="@/assets/new/bg_line-app.png" alt="bg_line" class="d-lg-none d-block">
            </div>
        </div>
        <!-- END // 深粉主題 -->

        <!-- 淺粉主題 -->
        <div class="lightPink">
            <!-- 51職人專區 -->
            <section id="worker" v-if="workerData !=''">
                <div class="h6"><img src="@/assets/new/sect_title_5.png" alt="51職人專區" class="d-block"></div>
                <div class="outBox modal-box">
                    <div class="container">
                        <ul class="row promo">
                            <template v-for="(item, index) in workerData" :key="index">
                                <bodyPD :item="item" :bgImg="'bg01'"/>
                            </template>
                        </ul>
                    </div>
                </div>
            </section>
            <!-- END // 51職人專區 -->

            <!-- 本日主打星 -->
            <section id="focus" v-if="brandPdData_1 != '' && brandPdData_2 !=''">
                <div class="h6"><img src="@/assets/new/sect_title_6.png" alt="本日主打星" class="d-block"></div>
                <div class="outBox modal-box">
                    <div class="container powerbrand_box">
                        <div class="main">
                            <ul class="row brandPD mb-4 mb-lg-0">
                                <template v-for="(item, index) in brandPdData_1">
                                    <brandPD v-if="index <5" :item="item" :index="index" :key="item.uniqueIdentifier" />
                                </template>
                            </ul>
                            <ul class="row brandPD mb-4 mb-lg-0">
                                <template v-for="(item, index) in brandPdData_1">
                                    <brandPD v-if="index >4 && index <10" :item="item" :index="index" :key="item.uniqueIdentifier" />
                                </template>
                            </ul>
                        </div>
                        <ul class="row brandPDPower" id="powerbrand_02" v-if="brandPdData_2">
                            <brandPDPower v-for="(item, index) in brandPdData_2" :item="item" :key="index"/>
                        </ul>
                    </div>
                </div>
            </section>
            <!-- END // 本日主打星 -->

            <!-- 注目大牌 -->
            <section id="brands" v-if="brandsData !=''">
                <div class="h6"><img src="@/assets/new/sect_title_7.png" alt="注目大牌" class="d-block"></div>
                <div class="outBox">
                    <pdSlide :data="brandsData" :item="brandsData"/>
                </div>
            </section>
            <!-- END // 注目大牌 -->

            <!-- 嚴選特搜 -->
            <section id="sbd" v-if="sbdbodyData != ''">
                <div class="h6">
                    <img src="@/assets/new/sect_title_8.png" alt="嚴選特搜" class="d-block">
                </div>
                <div class="outBox">
                    <div class="container">
                        <ul class="row sbdbody">
                            <template v-for="(item, index) in sbdbodyData">
                                <sbdbodyPD v-if="index <=5" :item="item" :index="index" :key="item.uniqueIdentifier" />
                            </template>
                        </ul>
                    </div>
                </div>
            </section>
            <!-- END // 嚴選特搜 -->

            <!-- 深粉主題2 -->
            <div class="deepPink2">
                <div class="bgLine top absolute d-lg-block d-none"></div>
                <!-- 折價券 -->
                <section id="coupon" v-if="couponData !=''">
                    <div class="h6"><img src="@/assets/new/sect_title_9.png" alt="折價券" class="d-block"></div>
                    <div class="container" v-if="couponData">
                        <couponNew />
                    </div>
                </section>
                <!-- END // 折價券 -->

                <!-- 限時瘋搶 -->
                <section id="flashdeal" v-if="onSale != ''">
                    <div class="h6">
                        <img src="@/assets/new/sect_title_10.png" class="d-block" alt="限時瘋搶看更多">
                    </div>
                    <div class="outBox">
                        <onSaleAll v-if="onSale" :onSale="onSale" :onSaleNowAll="onSaleNowAll" :onSale_0="onSale_0"
                            :onSale_1="onSale_1" :onSale_2="onSale_2" :onSale_3="onSale_3" :onSale_4="onSale_4" />
                    </div>
                </section>
                <!-- END // 限時瘋搶 -->
                <div class="bgLine btm absolute pe-none d-lg-block d-none"></div>
            </div>
            <!-- END // 深粉主題2 -->

            <!-- 家政女王 -->
            <section id="homemom" v-if="homemomData !=''">
                <div class="h6"><img src="@/assets/new/sect_title_11.png" alt="家政女王" class="d-block"></div>
                <div class="outBox modal-box">
                    <div class="container scrollPDBox">
                        <scrollPD :data="homemomData"/>
                    </div>
                </div>
            </section>
            <!-- END // 家政女王 -->

            <!-- 享樂媽咪 -->
            <section id="funmom" v-if="funmomData !=''">
                <div class="h6"><img src="@/assets/new/sect_title_12.png" alt="享樂媽咪" class="d-block"></div>
                <div class="outBox modal-box">
                    <div class="container">
                        <ul class="row promo">
                            <template v-for="(item, index) in funmomData" :key="index">
                                <bodyPD :item="item" :bgImg="'bg02'"/>
                            </template>
                        </ul>
                    </div>
                </div>
            </section>
            <!-- END // 享樂媽咪 -->

            <!-- 窈窕靚媽 -->
            <section id="beautymom" v-if="beautymomData !=''">
                <div class="h6"><img src="@/assets/new/sect_title_13.png" alt="窈窕靚媽" class="d-block"></div>
                <div class="outBox modal-box">
                    <div class="container scrollPDBox">
                        <scrollPD :data="beautymomData"/>
                    </div>
                </div>
            </section>
            <!-- END // 窈窕靚媽 -->

            <!-- 玩酷太太 -->
            <section id="coolmom" v-if="coolmomData !=''">
                <div class="h6"><img src="@/assets/new/sect_title_14.png" alt="玩酷太太" class="d-block"></div>
                <div class="outBox modal-box">
                    <div class="container">
                        <ul class="row promo">
                            <template v-for="(item, index) in coolmomData" :key="index">
                                <bodyPD :item="item" :bgImg="'bg02'"/>
                            </template>
                        </ul>
                    </div>
                </div>
            </section>
            <!-- END // 玩酷太太 -->
        </div>
        <!-- 淺粉主題 -->

        <!-- 深粉主題3 -->
        <div class="deepPink3">
            <div class="bgLine top absolute">
                <img src="@/assets/new/bg_line-app.png" alt="bg_line" class="d-lg-none d-block">
            </div>

            <!-- 精選會場 -->
            <section id="cate" v-if="cate !=''">
                <div class="h6"><img src="@/assets/new/sect_title_15.png" alt="精選會場" class="d-block"></div>
                <div class="container cate mb-md-5">
                    <guide :cate="cate"/>
                </div>
            </section>
            <!-- END // 精選會場 -->

            <div class="bgLine btm absolute pe-none">
                <img src="@/assets/new/bg_line-app.png" alt="bg_line" class="d-lg-none d-block">
            </div>
        </div>
        <!-- END // 深粉主題3 -->

        <seoTxt />
        <Footer />
    </div>
    <!-- END // wrap -->

    <!-- Modal -->
    <div class="modal fade" id="calendar" tabindex="-1" aria-labelledby="calendarLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">購物攻略</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <img src="@/assets/ui/cancel.svg" alt="" class="d-block">
                    </button>
                </div>
                <div class="modal-body">
                    <template v-for="(item, index) in otherData" :key="item.uniqueIdentifier">
                        <img v-if="index === 2" :src="item.Img.Src" alt="攻略" class="d-block">
                        <img v-if="index === 3" :src="item.Img.Src" alt="攻略" class="d-block">
                    </template>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue';
import ScrollActive from 'scroll-active';
import axios from "axios";
import { linkMixin } from './components/mixin.js';
import HeaderTop from './components/ui/Header.vue'
import Footer from './components/ui/Footer.vue'
import seoTxt from './components/body/_seoTxt.vue'
import RightMenu from './components/ui/RightMenu.vue'
import LeftMenu from './components/ui/LeftMenu.vue'
import onSaleNowFirst from './components/body/_onSaleNowFirst.vue'
import onSaleAll from './components/body/_onSaleAll.vue'
import linkImg from './components/body/_linkImg.vue'
import bankSlide from './components/body/_bankSlide.vue'
import guide from './components/body/_guide.vue'
import brandPD from './components/body/_brandPD.vue'
import brandPDPower from './components/body/_brandPDPower.vue'
import slideBn from './components/body/_slideBn.vue'
import superPD from './components/body/_superPD.vue'

import previewMoreAD from './components/body/_previewMoreAD.vue'
import bodyPD from './components/body/_bodyPD.vue'
import oneDay from './components/body/_oneDay.vue'
import sbdbodyPD from './components/body/_sbdbodyPD.vue'
import pdSlide from './components/body/_pdSlide.vue'
import cardSlide from './components/body/_cardSlide.vue'
import couponNew from './components/body/_couponNew.vue'
import scrollPD from './components/body/_scrollPD.vue'
import 'swiper/css/bundle'
import '@/assets/css/layout.css';


// ---------------------------------
// (2) 讀取後台資料並重組資料格式
// ---------------------------------
let dataArr = {};
function toDataArr (arr){
    arr.forEach(function(item){
        dataArr[item.BlockId] = item;
    });
}

//計算區塊實際資料 (因IndexBlock資料中有空白陣列)
function dataNode(data, blockNumFirst) {
    for(let i=blockNumFirst; i<=(blockNumFirst + 9); i++){
        if(dataArr[i]){
            dataArr[i].Nodes.forEach(function(node){
                // 檢查node.Link.Ur，如有資料再堆疊至新陣列{}
                if(node.Link.Url){
                    data.push(node);
                }
            });
        }
    }
}
let topBnData = [];
let bnEvent_1Data = [];
let bnEvent_2Data = [];
let bnHeroData = [];
let couponBnData = [];
let bankWebData = [];
let bankAppData = [];
let previewMoreData = [];
let sbdpreviewData = [];
let saleAuctionData = [];
let supersaleData = [];
let workerData = [];
let brandPdData_1 = [];
let brandPdData_2 = [];
let sbdbodyData = [];
let couponData = [];
let homemomData = [];
let funmomData=[];
let beautymomData=[];
let coolmomData = [];

let brandsData = [];
let cate = [];
let otherData = [];


export default {
    name: 'App',
	mixins: [linkMixin],
	data: () => {
        return {
            hashMenu: [
                {
                    "name": "銀行優惠",
                    "data": bankWebData,
                    "hash": "bank"
                },
                {
                    "name": "加碼必看",
                    "data": previewMoreData,
                    "hash": "discount"
                },
                {
                    "name": "強檔預告",
                    "data": sbdpreviewData,
                    "hash": "sbdpreview"
                },
                {
                    "name": "快速送禮",
                    "data": supersaleData,
                    "hash": "supersale"
                },
                {
                    "name": "願望清單",
                    "data": saleAuctionData,
                    "hash": "wishlist"
                },
                {
                    "name": "51職人專區",
                    "data": workerData,
                    "hash": "worker"
                },
                {
                    "name": "本日主打星",
                    "data": brandPdData_1,
                    "hash": "focus"
                },
                {
                    "name": "注目大牌",
                    "data": brandsData,
                    "hash": "brands"
                },
                {
                    "name": "嚴選特搜",
                    "data": sbdbodyData,
                    "hash": "sbd"
                },
                {
                    "name": "必搶神券",
                    "data": couponData,
                    "hash": "coupon"
                },
                {
                    "name": "限時瘋搶",
                    "data": "onSaleNowAll",
                    "hash": "flashdeal"
                },
                {
                    "name": "家政女王",
                    "data": homemomData,
                    "hash": "homemom"
                },
                {
                    "name": "享樂媽咪",
                    "data": funmomData,
                    "hash": "funmom"
                },
                {
                    "name": "窈窕靚媽",
                    "data": beautymomData,
                    "hash": "beautymom"
                },
                {
                    "name": "玩酷太太",
                    "data": coolmomData,
                    "hash": "coolmom"
                },
                {
                    "name": "精選會場",
                    "data": cate,
                    "hash": "cate"
                },
            ],
            // 瘋殺 from api 
			onSale: null,
            onSaleNowAll: null,
            onSaleNowFirst: null,
            onSale_0: null,
            onSale_1: null,
            onSale_2: null,
            onSale_3: null,
            onSale_4: null,
            // ---------------
            topBnData: topBnData,
            bnEvent_1Data: bnEvent_1Data,
            bnEvent_2Data: bnEvent_2Data,
            bnHeroData: bnHeroData,
            couponBnData: couponBnData,
            bankWebData: bankWebData,
            bankAppData: bankAppData,
            previewMoreData: previewMoreData,
            sbdpreviewData: sbdpreviewData,
            saleAuctionData: saleAuctionData,
            supersaleData: supersaleData,
            workerData: workerData,
            brandPdData_1: brandPdData_1,
            brandPdData_2: brandPdData_2,
            sbdbodyData: sbdbodyData,
            homemomData: homemomData,
            funmomData: funmomData,
            beautymomData:beautymomData,
            coolmomData: coolmomData,

            brandsData: brandsData,
            couponData: couponData,
            cate: cate,
            // honey: honey,
            // dream: dream,
            // dateData: dateData,
            otherData: otherData,
        }
    },
    components: {
        Swiper,
        SwiperSlide,
        
        // UI元件 ----
        HeaderTop,
        Footer,
        RightMenu,
        LeftMenu,

        // 版身內容元件 ----
        bankSlide,
        bodyPD,
        brandPD,
        brandPDPower,
        cardSlide,
        couponNew,
        previewMoreAD,
        guide,
        linkImg,
        oneDay,
        onSaleAll,
        onSaleNowFirst,
        pdSlide,
        sbdbodyPD,
        seoTxt,
        slideBn,
        superPD,
        scrollPD,
    },
    setup() {
        return {
            modules: [Navigation, Pagination, Autoplay],
        };
    },
    created() {
		// 讀取後台資料並重組資料格式
		toDataArr(IndexBlock);
        setTimeout(() => {
            // console.log('OK');
            dataNode(this.topBnData, 31); //2大bn
            dataNode(this.bnEvent_1Data, 42); //一堆bn
            dataNode(this.bnEvent_2Data, 53); //一堆bn
            dataNode(this.bnHeroData, 64); //hero bn slide
            dataNode(this.couponBnData, 220); //折價券AD
            dataNode(this.bankWebData, 231); //銀行
            dataNode(this.bankAppData, 242); //銀行
            dataNode(this.previewMoreData, 88); // 加碼必看
            dataNode(this.sbdpreviewData, 99); // 強檔預告
            dataNode(this.supersaleData, 110); //24H 快速送禮
            dataNode(this.saleAuctionData, 121); //願望清單
            dataNode(this.workerData, 289); //51職人專區
            dataNode(this.brandPdData_1, 300); // 本日主打星(上)
            dataNode(this.brandPdData_2, 311); // 本日主打星(下)
            dataNode(this.brandsData, 673); //注目大牌
            dataNode(this.sbdbodyData, 684); //嚴選特搜
            dataNode(this.couponData, 695); //折價券 695，706
            dataNode(this.homemomData, 717); //家政女王
            dataNode(this.funmomData, 728); //享樂媽咪
            dataNode(this.beautymomData, 739); //窈窕靚媽
            dataNode(this.coolmomData, 750); //玩酷太太
            dataNode(this.cate, 761); //精選會場
            // ------------------
            dataNode(this.otherData, 772); //其他資料 右貼，小標換檔

            

            // ------------------------------------
            // 取得瘋殺資料, 本機端&雲端
            // 因瘋殺api綁網址，必須雲端才可取得
            // 所以本機端可先用舊資料預覽排版
            // 本地端判斷設定 localset.js
            // ------------------------------------
            const nowUrl = window.location.href;
            const serchWord = nowUrl.indexOf('24h.pchome');
            let dataURL = '';
            // 檢查網址址是否有包含'pchome'，沒有=本機，有=雲端
            (serchWord < 0) 
                ? dataURL = 'js/onsale.json' //本機端
                // : dataURL = 'js/onsale.json'; //雲端
                // ? dataURL = `https://ecapi-cdn.pchome.com.tw/fsapi/cms/onsale`
                : dataURL = `https://ecapi-cdn.pchome.com.tw/fsapi/cms/onsale`; 

            axios.get(dataURL)
            .then(response => {
                // 成功取得資料，取9筆
                // console.log('response: ', response.data.data);
                this.onSale = response.data.data;
                this.onSaleNowAll = this.getRandomProducts(this.onSale[0].products, 9);
                this.onSaleNowFirst = this.onSaleNowAll[0];
                this.onSale_0 = response.data.data[0];
                this.onSale_1 = response.data.data[1];
                this.onSale_2 = response.data.data[2];
                this.onSale_3 = response.data.data[3];
                this.onSale_4 = response.data.data[4];

                // ------------
                // console.log('onSale: ', this.onSale);
                // console.log('onSaleNowAll: ', this.onSaleNowAll );
                // console.log('onSaleNowFirst: ', this.onSaleNowFirst);
                // console.log('otherData: ', this.otherData);
            })
            .catch(error => {
                // 處理錯誤
                console.error('API 請求失敗:', error);
            });

        }, 110);
    },
    methods: {
        getRandomProducts(products, count) {
            const productsRandom = JSON.parse(JSON.stringify(products));
            for (let i = productsRandom.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [productsRandom[i], productsRandom[j]] = [productsRandom[j], productsRandom[i]];
            }
            // 從洗牌後的數組中取出指定數量的元素
            return productsRandom.slice(0, count);
        },
        indexRenderEven(index) {
            // even偶數，index % 2 === 0
            return index % 2 === 0; // Change to index % 2 === 1 for odd numbers
        },
        indexRenderOdd(index) {
            // odd奇数，index % 2 === 1
            return index % 2 === 1; // Change to index % 2 === 1 for odd numbers
        },
        initScrollActive() {
            const windowWidth = window.innerWidth;
            let scrollOffset = 0;
            (windowWidth <= 991) && ( scrollOffset = 40);
            this.sa.dispose();
            this.sa = new ScrollActive({ 
                activeClass: 'active',
                offset: scrollOffset,
                inViewport: true,
                hash: false, //網址列不顯示hash
                update() {
                    this.navbar = document.getElementById('navbar');
                    setTimeout(() => {
                        const activeLi = this.navbar.querySelector('li.active');
                        if (activeLi) {
                            const menuMove = document.querySelector(".right__menu");
                            menuMove.scrollLeft = activeLi.offsetLeft - windowWidth / 2;
                        }
                    }, 100);
                }
            });
        }
    },
    mounted() {
		// 在元素渲染完成後執行
        this.$nextTick(() => {
            initSetting();

            const kvTitle = document.querySelector('.kvBox .kvTitle');
            setTimeout(() => {
                kvTitle.classList.add('ani');
            }, 600);

            const guide = document.querySelector('.kvBox .smallP');
            setTimeout(() => {
                guide.classList.add('ani');
            }, 1200);
            setTimeout(() => {
                guide.classList.add('jump');
            }, 3000);
            this.sa = new ScrollActive();
        });
        
        
        // app選單 下滑置頂後固定
        const appTopNav = document.getElementById('appTopNav');
        window.addEventListener('scroll', function() {
            const scrollY = window.scrollY || window.pageYOffset;
            if (scrollY >= appTopNav.offsetTop) {
                appTopNav.classList.add('active');
            } else {
                appTopNav.classList.remove('active');
            }
        });
    },
    updated() {
        this.initScrollActive();
    },
    beforeUnmount() {
        this.initScrollActive();
    }

}
function initSetting() {

	// 網址有hashtag錨點，網頁載入後下滑
    let hashTag = location.hash;
    if (hashTag != '') {
        console.log(hashTag);
        setTimeout(() => {
            const myElement = document.querySelector(hashTag);
            myElement.scrollIntoView({ behavior: 'instant', });
        }, 1000);
    } 
}
</script>

<style>
/* @import "~bootstrap/dist/css/bootstrap.css"; */
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

</style>
